import { render, staticRenderFns } from "./UniversityOrCityTypeahead.vue?vue&type=template&id=87862790"
import script from "./UniversityOrCityTypeahead.vue?vue&type=script&lang=ts"
export * from "./UniversityOrCityTypeahead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports